import React from "react";
import TabLayout from "../../components/TabLayout";
import ReviewResponse from "./ReviewResponse";
import ReviewComments from "./ReviewComments";
import {Grid} from "@mui/material";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";

export default function ResponseTabs(props) {
    return (
        <Grid container spacing={0.5}>
            <Grid item xs={12}><Typography variant="h5">Responses</Typography></Grid>
            <Grid item xs={12}><Divider/></Grid>
            <Grid item xs={12}>
                <TabLayout
                    tabs={[
                        {title: "Review Response", component: <ReviewResponse/>},
                        {title: "Review Comments", component: <ReviewComments/>},
                    ]}
                />
            </Grid>
        </Grid>
    );
}